import Typecheck from "../utils/Typecheck";
import {ConstructorEnvironment} from "../data";

export const useConstructorEnvironment = () => {
    return window.constructorEnvironment && Typecheck.isEnumValue(window.constructorEnvironment, ConstructorEnvironment)
        ? window.constructorEnvironment
        : ConstructorEnvironment.cart;
};
